import {AuctionTypeFilter} from '../types/AuctionTypeFilter';
import {AuctionSourcingListItem} from './adaptAuctionVehicleToSourcingItem';
import {isHiddenAuctionType} from './isHiddenAuctionType';

type AuctionPrice = Pick<
  AuctionSourcingListItem['auctionVehicle'],
  'auctionType' | 'priceActual' | 'priceBuyNow' | 'priceMinimum'
>;

/** A direct purchase shows its purchase price once, falling back to the current price. */
export function getAuctionDisplayPrice(auction: AuctionPrice) {
  if (isHiddenAuctionType(auction.auctionType)) {
    return auction.priceMinimum;
  }
  return auction.auctionType?.toLowerCase() === AuctionTypeFilter.BUY_NOW &&
    (auction.priceBuyNow ?? 0) > 0
    ? auction.priceBuyNow
    : auction.priceActual;
}
